import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import styles from "./primary.module.css"

@tagName("")
export default class MenuPrimaryTitle extends Component {
  readonly styles = styles
}
